var React = require('react');

function IconArrowDownSd (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_3_2)","key":0},React.createElement("path",{"d":"M23.6769 4.70088C24.5909 3.17788 23.4939 1.22888 21.7099 1.22888H2.29592C0.511915 1.22888 -0.585085 3.17788 0.328915 4.70088L10.0379 20.8809C10.9289 22.3639 13.0789 22.3609 13.9679 20.8809L23.6769 4.70088Z","fill":"#fff"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_3_2"},React.createElement("rect",{"width":"24","height":"24","fill":"none"})))]);
}

IconArrowDownSd.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IconArrowDownSd;

IconArrowDownSd.default = IconArrowDownSd;
